import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Alert, Modal, ModalBody } from 'reactstrap';
import moment from 'moment/moment';
import { newBooking } from '../../actions/BookingAction';
import { getEvents } from '../../actions/EventsAction';
import { updateMeBooking } from '../../actions/ProfilAction';

class BookingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
      error: false,
      email: '',
      phone: '',
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => this.props.ToggleModal()
    );
  }

  Booking() {
    this.props.updateMeBooking(
      this.props.token,
      document.getElementById('phone').value,
      document.getElementById('email').value,
      () =>
        this.props.newBooking(
          this.props.token,
          document.getElementById('event').value,
          document.getElementById('note').value,
          document.getElementById('members').value,
          document.getElementById('date').value,
          this.props.eventsBySlug[0].groupe._id,
          () => {
            this.toggle();
            alert(
              'Votre réservation a été envoyée avec succes. Notre équipe vérifiera la disponibilité de votre demande et répondra par téléphone ou par email dans les plus brefs délais.'
            );
          },
          () => {
            this.setState({
              error: true,
            });
          }
        )
    );
  }

  render() {
    const email =
      this.props.user.local && this.props.user.local.email
        ? this.props.user.local.email
        : this.props.user.facebook && this.props.user.facebook.email
        ? this.props.user.facebook.email
        : null;
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className="txt-white pt-x"
        external={
          <button className="close" style={{ position: 'absolute', top: 25, right: 25, color: 'white' }}>
            <span className="fas fa-times" />
          </button>
        }
      >
        <ModalBody>
          <div className="row mb-3">
            <h2 className="col-12 text-center mb-4">Reservation</h2>
            {this.props.eventsBySlug ? (
              <div className="col-12 mb-3 row">
                <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                  <span className="fas fa-tag" />
                </span>
                <select className="input-login col-10" id="event" name="event" form="event">
                  <option value="null" disabled selected>
                    Reservation hors événements...
                  </option>
                  {this.props.eventsBySlug.map(
                    item => moment().isAfter(item.date) || <option value={item._id}>{item.name}</option>
                  )}
                </select>
              </div>
            ) : (
              <Fragment />
            )}
            <div className="col-12 mb-2 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="fas fa-users" />
              </span>
              <input
                id="members"
                className="input-login col-10"
                placeholder="Nombre des places"
                type="number"
                name="Nombre des places"
              />
            </div>
            <div className="col-12 mb-2 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="far fa-calendar-alt" />
              </span>
              <input type="datetime-local" id="date" className="input-login col-10" name="date" min={new Date()} />
            </div>
            <div className="col-12 mb-2 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="far fa-comment-alt" />
              </span>
              <textarea className="col-10 input-login" id="note" placeholder="Note" />
            </div>
          </div>
          <Alert color="info">
            <span className="fas fa-info-circle" style={{ marginRight: 5 }} />
            Vous devez revérifier votre numéro de téléphone et votre courrier électronique, car nous les utilisons pour répondre
            à votre demande.
          </Alert>
          <div className="col-12 mb-5">
            <div className="col-12 mb-2 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="fas fa-phone" />
              </span>
              <input
                id="phone"
                required
                defaultValue={this.props.user.phone ? this.props.user.phone : ''}
                className="input-login col-10"
                placeholder="Numéro du téléphone"
                type="tel"
                name="Numéro du téléphone"
              />
            </div>
            <div className="col-12 mb-2 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="far fa-envelope-open" />
              </span>
              <input
                id="email"
                required
                defaultValue={email || ''}
                className="input-login p-2 col-10"
                placeholder="Email"
                type="email"
                name="Email"
                disabled={email}
              />
            </div>
          </div>
          <div className="col-12 row">
            <div className="col-2" />
            <button className="btn-custom btn-silver col-4" onClick={this.toggle}>
              Annuler
            </button>
            <div className="col-2" />
            <button className="btn-custom btn-purple col-4" onClick={this.Booking.bind(this)}>
              Confirmer
            </button>
          </div>
          <br />
          <div className="row" hidden={!this.state.error}>
            <Alert color="danger" className="offset-2 col-8">
              La réservation a été echouée.
            </Alert>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = store => {
  return {
    user: store.login.user,
    token: store.login.token,
  };
};
export default connect(mapStateToProps, { getEvents, newBooking, updateMeBooking })(BookingModal);



// WEBPACK FOOTER //
// ./src/components/Modals/BookingModal.js